import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { AGENTS } from "../data/agents";

export default function AgentiAiPage() {
  return (
    <div className="px-5 sm:px-8 lg:px-12 py-16 sm:py-20 max-w-6xl mx-auto">
      <Link
        to="/servizi"
        data-testid="agenti-back-link"
        className="inline-flex items-center gap-2 text-[11px] tracking-[0.28em] uppercase text-white/40 hover:text-white/80 transition mb-10"
      >
        <ChevronLeft className="w-3.5 h-3.5" />
        Torna a Servizi
      </Link>

      <PageHeader
        eyebrow="Servizi · Agenti AI"
        title="Agenti AI."
        description="Le entità intelligenti al servizio dell'ecosistema TIME."
        testId="agenti-header"
      />

      <div
        data-testid="agenti-grid"
        className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8"
      >
        {AGENTS.map((agent) => (
          <Link
            key={agent.slug}
            to={`/servizi/agenti-ai/${agent.slug}`}
            data-testid={`agent-${agent.slug}`}
            className="group block"
          >
            <div className="relative aspect-square rounded-2xl overflow-hidden bg-white/[0.02] border border-white/5 shadow-[0_10px_40px_-15px_rgba(0,0,0,0.6)] transition-all duration-500 group-hover:-translate-y-2 group-hover:shadow-[0_25px_60px_-15px_rgba(212,175,55,0.35)] group-hover:border-amber-400/30">
              <img
                src={agent.image}
                alt={agent.name}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
              />
              <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/85 via-black/40 to-transparent pointer-events-none" />
              <div className="absolute inset-x-0 bottom-0 p-6 sm:p-7">
                <div className="text-[10px] tracking-[0.32em] uppercase text-amber-300/80 mb-2">
                  {agent.role}
                </div>
                <div className="text-2xl sm:text-3xl font-extralight text-white tracking-tight">
                  {agent.name}
                </div>
                <div className="mt-2 text-xs font-light text-white/60 leading-relaxed max-w-md">
                  {agent.tagline}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
